import axios from "axios";
require("dotenv").config();

export function isValidResponse(resp) {
  return resp && resp.status === 200 && resp.data.status === 1;
}
export const BUCKET_BASE_URL = process.env.VUE_APP_BUCKET_BASE_URL;
export const OUTBOUND_BASE_URL = process.env.VUE_APP_OUTBOUND_BASE_URL;
export const NGB_CONDUCTOR = process.env.VUE_APP_CONDUCTOR_URL;
export const NGB = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});
export const NGB_SOCKET = axios.create({
  baseURL: process.env.VUE_APP_SOCKET_URL,
});
export const NGB_PAYMENT = axios.create({
  baseURL: process.env.VUE_APP_PAYMENT_URL,
});
export const NGB_ALLOWANCE = axios.create({
  baseURL: process.env.VUE_APP_ALLOWANCE_URL,
});
export const api = {
  NGB,
  NGB_SOCKET,
  NGB_PAYMENT,
  NGB_ALLOWANCE,
};
export const methods = {
  DELETE: "DELETE",
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  WITHOUT_BODY_POST: "WITHOUT_BODY_POST",
};

export class APIError {
  message;

  constructor(msg) {
    this.message = msg;
  }

  get getMessage() {
    return this.message;
  }
}

export const headers = {
  "Content-Type": "application/json",
  "ngb-platform-tenantid": "default",
};

//const userToken = JSON.parse(sessionStorage.getItem("ngb:user_token")) || null;
const bearerToken = (sessionStorage.getItem("ngb:bearer_token")) || null;
//if (userToken) {
  //headers.Authorization = `Basic ${userToken}`;
//}
if (bearerToken) {
  headers.Authorization = `Bearer ${bearerToken}`;
}
export const setBearerToken = (token) => {
  headers.Authorization = `Bearer ${token}`;
}

export const setAuthorizationHeader = (token) => {
  headers.Authorization = `Basic ${token}`;
};
export const removeHeader = (key) => {
  delete headers[key];
};
export const setHeader = (key, value) => {
  headers[key] = value;
};

export const serviceMaker = async (url, type, service, data, customHeaders) => {
  try {
    let result;
    const APIInstance = service || NGB;
    let combinedHeaders = {
      ...headers,
      ...customHeaders,
    };
    if (APIInstance == NGB_ALLOWANCE) {
      delete combinedHeaders["ngb-platform-tenantid"];
      combinedHeaders["Content-Type"] = "application/json";
    }

    switch (type) {
      case "GET": {
        result = await APIInstance.get(url, { headers: combinedHeaders });
        break;
      }
      case "POST": {
        result = await APIInstance.post(url, data, {
          headers: combinedHeaders,
        });
        break;
      }
      case "PUT": {
        result = await APIInstance.put(url, data, { headers: combinedHeaders });
        break;
      }
      case "DELETE": {
        result = await APIInstance.delete(url, { headers: combinedHeaders });
        break;
      }
      default: {
        // eslint-disable-next-line no-throw-literal
        throw "InvalidMethod";
      }
    }
    if (!isValidResponse) {
      // eslint-disable-next-line no-throw-literal
      throw "InvalidResponse";
    }
    return result;
  } catch (err) {
    // tslint:disable-next-line:no-console
    throw new APIError(
      err.response ? err.response.data : "Something went wrong"
    );
  }
};
